<template>
  <div class="empty-position--components">
    <i class="iconfont icon-wushuju"></i>
    <div class="msg">{{msg}}</div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'base'
    }
  },
  data() {
    return {
      msg: '',
      msgMap: {
        "base": "还没有相关内容",
        "notice": "还没有消息通知",
        "follow": '还没有关注的人',
        "fans": '还没有粉丝',
        "fav": '还没有收藏内容',
        "comment": '还没有评论内容',
        "good": '还没有点有用内容',
        "article": '还没有文章内容',
        "video": '还没有视频内容',
        "extendIntroduction": '还没有个人介绍，请至账户后台编辑',
      }
    }
  },
  created() {
    this.msg = this.msgMap[this.type]
  }
};
</script>
<style lang='scss' scoped>
.empty-position--components {
  margin: 55px 0;
  text-align: center;
  .icon-wushuju {
    font-size: 92px;
  }
  .msg {
    font-weight: bold;
    font-size: $font-size-big;
    color: $text-main;
  }
}
</style>